module.exports = __webpack_public_path__ + "img/9788934926191.6d922199.jpg";